import { type ColumnDensity } from '@/components/Table/TableCell'
import { type WaitingOn } from '@/features/jobs/Job'
import {
  allJobPeriodFilterOptions,
  type JobPeriodFilterOption,
} from './job-period-filter-option'
import {
  allJobProgressionStepFilterOptions,
  type JobProgressionStepFilterOption,
} from './job-progression-filter-option'
import {
  allJobScopeChangeStatusFilterOptions,
  type JobScopeChangeStatusFilterOption,
} from './job-scope-change-status-filter-option'
import {
  allJobStatusFilterOptions,
  type JobStatusFilterOption,
} from './job-status-filter-option'

/*
 * Users' saved list settings outlive releases. Values saved before these
 * options were strings are numbers: their position in the option lists,
 * which must therefore never be reordered.
 */

const columnDensities: readonly ColumnDensity[] = [
  'Default',
  'Comfortable',
  'Compact',
]

export function parseStoredJobStatusFilterOption(
  value: unknown,
): JobStatusFilterOption | null {
  return parseStoredOption(allJobStatusFilterOptions, value)
}

export function parseStoredJobPeriodFilterOption(
  value: unknown,
): JobPeriodFilterOption | null {
  return parseStoredOption(allJobPeriodFilterOptions, value)
}

export function parseStoredJobProgressionStepFilterOption(
  value: unknown,
): JobProgressionStepFilterOption | null {
  return parseStoredOption(allJobProgressionStepFilterOptions, value)
}

export function parseStoredJobScopeChangeStatusFilterOption(
  value: unknown,
): JobScopeChangeStatusFilterOption | null {
  return parseStoredOption(allJobScopeChangeStatusFilterOptions, value)
}

export function parseStoredColumnDensity(value: unknown): ColumnDensity | null {
  return parseStoredOption(columnDensities, value)
}

/**
 * Parses a stored Waiting on filter value, which used to be the API's
 * `WaitingOn` number.
 */
export function parseStoredWaitingOn(value: unknown): WaitingOn | null {
  switch (value) {
    case 'Client':
    case 1:
      return 'Client'
    case 'Provider':
    case 2:
      return 'Provider'
    default:
      return null
  }
}

function parseStoredOption<T extends string>(
  options: readonly T[],
  value: unknown,
): T | null {
  if (typeof value === 'number') {
    return options[value] ?? null
  }

  return options.find((o) => o === value) ?? null
}
